import React from 'react';
import Hero from './components/about-us/vice-chancellor/Hero';
import Main from './components/about-us/vice-chancellor/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const ViceChancellor = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default ViceChancellor;